import { Response } from 'miragejs';
import type { Server } from 'miragejs';
import { response } from 'mocks/helpers';

export const imageEndpoints = (server: Server) => {
  server.get('http://localhost:4200/images/:name', async (schema, request) => {
    const buffer = await fetch(`/src/mocks/data/images/${request.params.name}.jpeg`).then(res =>
      res.arrayBuffer()
    );
    return response(request.url, undefined, {
      statusCode: 200,
      headers: { 'Content-Type': 'image/jpeg' },
      body: buffer,
    });
  });
};
